import feeOnTransferCheckAbi from "@/constants/abi/feeOnTransferCheck";
import { chainSettings, fallbackChainId, type ChainType } from "@/constants/chain-specific";
import { DEX_LIST } from "@/constants/project-specific/farms/dex";
import { useEffect, useState } from "react";
import type { Address } from "viem";
import { useSimulateContract } from "wagmi";
interface Props {
  addresses: Address[];
  factoryAddress?: Address;
  chainId?: ChainType;
}
const FEE_CACHE: { [address in string]?: {
  sellTax?: number;
  buyTax?: number;
} } = {};
export function useSwapTax({
  addresses,
  chainId,
  factoryAddress
}: Props) {
  const [sellFee, setSellFee] = useState<number | null>(null);
  const [buyFee, setBuyFee] = useState<number | null>(null);
  const [isTax, setIsTax] = useState<boolean>(false);
  const AMOUNT_TO_BORROW = 1000000000000000n;
  const result = useSimulateContract({
    abi: feeOnTransferCheckAbi,
    address: (chainSettings[chainId ?? fallbackChainId] as any)?.fotDetectorContract,
    functionName: "validate",
    args: [factoryAddress ?? DEX_LIST.chewyswap.factory.address, addresses[0], chainSettings[chainId ?? fallbackChainId].wNative.address, AMOUNT_TO_BORROW],
    query: {
      enabled: FEE_CACHE[addresses[0]] === undefined
    },
    chainId: chainId ?? fallbackChainId
  });
  useEffect(() => {
    if (result?.isError) {
      console.log(result.error?.message);
      setSellFee(null);
      setBuyFee(null);
      setIsTax(false);
    }
    if (result?.isFetched && result?.data) {
      if (addresses[0] && FEE_CACHE[addresses[0]] === undefined) {
        addresses.push(addresses[0]);
      } else {
        return;
      }
      console.log(result.data);
      FEE_CACHE[addresses[0]] = {
        sellTax: Number(result?.data?.result?.sellFeeBps) / 100,
        buyTax: Number(result.data.result.buyFeeBps) / 100
      };
      setSellFee(Number(result.data.result.sellFeeBps) / 100);
      setBuyFee(Number(result.data.result.buyFeeBps) / 100);
      setIsTax(Number(result.data.result.sellFeeBps) / 100 > 0 || Number(result.data.result.buyFeeBps) / 100 > 0);
    }
  }, [result, addresses, factoryAddress]);
  return {
    sellFee: sellFee ? FEE_CACHE[addresses[0]]?.sellTax : 0,
    buyFee: buyFee ? FEE_CACHE[addresses[0]]?.buyTax : 0,
    isTax,
    result
  };
}